'use strict';

/**
 * @private
 * @function
 * @description Binds the events of the order, address and payment pages
 */

import landingPage from './landing-page.js';
import configurationPreferences from './configuration-preferences.js';
// import shippingBillingPage from './shipping-billing-page.js';
import ordersAndReplenishments from './orders-and-replenishments.js';
import beautyConsultation from './beauty-consultation.js';
import whishlists from './wishlists.js';
import account from '../account.js';

var beautystation = {
    init: function () {
        landingPage.init();
        configurationPreferences.init();
        shippingBillingPage.init();
        ordersAndReplenishments.init();
        beautyConsultation.init();
        whishlists.init();
        account.init();
    }
};

export default beautystation;
